export const ANALYTICS_PATH = '/analytics';

export const LIVEOPS_PATH = '/liveops';

export const SUPPORT_PATH = '/support';

export const CONFIGURATION_PATH = '/configuration';
